import { createTheme } from '@material-ui/core/styles';
export const colorPrimary = '#1A1A1A';
export const primary002 = '#F2F2F2';
export const fontFamilyRegular = 'PoppinsRegular';
export default createTheme({
    palette: {
        primary: {
            main: `${colorPrimary}`,
            contrastText: '#ffffff',
            dark: '#1A1A1A',
            light: '#F2F2F2',
        },
        grey: {
            300: '#767676',
        },
        warning: {
            500: '#F2D4BD',
        },
    },
    typography: {
        h2: {
            fontFamily: 'Raleway',
            fontWeight: 700,
            fontSize: '2.5rem',
            color: `${colorPrimary}`,
            lineHeight: 1.5,
        },

        subtitle1: {
            fontSize: '1.25rem',
            fontWeight: 300,
            color: `${colorPrimary}`,
        },

        body1: {
            fontSize: '16px',
            fontWeight: 400,
            color: `${colorPrimary}`,
            fontFamily: 'Raleway',
        },
    },
    overrides: {
        MuiInputLabel: {
            root: {
                color: `${colorPrimary}`,
                fontSize: '16px',
                fontFamily: 'PoppinsRegular',
                top: '-13px!important',
            },
        },
        MuiInput: {
            root: {
                color: `${colorPrimary}`,
                fontWeight: 300,
            },
            underline: {
                '&:before': {
                    borderBottom: `3px solid`,
                    // bottom: "-10px",
                },
            },
        },
    },
});
